module.exports = __webpack_public_path__ + "static/media/StartButton.5bbb3ede.mp3";